<template>
    <div class="profile-blurred-banner">
        <div class="container">
            <div class="row">
                <div class="col-md-12 d-flex align-items-end justify-content-center">
                    <span class="text-center">
                        {{ translate.account.lockedProfile.yourProfileIsLockedBanner }}
                        &nbsp;<span class="text-underline cursor-pointer" v-html="translate.account.lockedProfile.unlockNow" @click="showModal"></span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

const data = () => {
    return {
        store: $store,
    }
}

function showModal() {
    this.store.commit('setProfileBlurredModalForceShow', true);
}

export default {
    data,
    computed: {
        ...mapState(['translate'])
    },
    methods: {
        showModal
    },
}
</script>
